import { LOGOUT_FORCED } from '../mutation-types';

interface ILogoutState {
    status: boolean;
}

const state = {

    status: false

};

const mutations = {

    [ LOGOUT_FORCED ]( state: ILogoutState, status: boolean ): void {

        state.status = status;

    }

};

export default {

    state,
    mutations

};
